import { create } from 'zustand';
import { AppState } from './types';
import { createSettingsSlice } from './slices/settingsSlice';
import { createMitarbeiterSlice } from './slices/mitarbeiterSlice';
import { createCoreDataSlice } from './slices/coreDataSlice';
import { createRolloverSlice } from './slices/rolloverSlice';
import { createUiSlice } from './slices/uiSlice';

// 💉 CHIRURGIE: Import des Betty Slice
import { createBettySlice } from './slices/bettySlice';
import { createPremiumSlice } from './slices/premiumSlice';
import { createPeProfitSlice } from './slices/peProfitSlice';
import { createTeamBonusSlice } from './slices/teamBonusSlice';
import { normalizeLandCode, resolveActiveCountry } from './slices/settingsSlice';

// 💉 CHIRURGIE-FIX: Der Matroschka-Normalisierer & das Währungs-Diktat
const normalizeState = (state: any) => {
  // 1. Den Doppel-Verschachtelungs-Tumor entfernen
  if (state.clientData && state.clientData.clientData) {
    const nestedData = state.clientData.clientData;
    state.clientData = {
      ...state.clientData,
      ...nestedData
    };
    delete state.clientData.clientData;
  }

  // 2. DAS EISERNE WÄHRUNGS- UND LÄNDER-DIKTAT
  // Volles Länderprofil neu aufbauen — sonst bleiben DE-Lohnnebenkosten bei IT kleben
  const rawLand = state.clientData?.land || state.clientData?.Land || state.settings?.selectedCountryId || 'DE';
  const activeLand = normalizeLandCode(rawLand);

  if (state.clientData) {
    state.clientData.land = activeLand;
    delete state.clientData.Land; 
  }

  if (state.settings) {
      state.settings.selectedCountryId = activeLand;
      state.settings.country = resolveActiveCountry(state.settings, state.clientData);
  }

  return state;
};

// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// THE ROOT STORE
// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

const useAppStore = create<AppState>()((set, get, api) => {
  const sanitizedSet = (partial: any, replace?: boolean) => {
    set((state) => {
      const patch = typeof partial === 'function' ? partial(state) : partial;
      if (replace) {
        return normalizeState(patch);
      }
      return normalizeState({ ...state, ...patch });
    }, replace);
  };

  return {
    ...createSettingsSlice(sanitizedSet, get, api),
    ...createMitarbeiterSlice(sanitizedSet, get, api),
    ...createCoreDataSlice(sanitizedSet, get, api), 
    ...createRolloverSlice(sanitizedSet, get, api), 
    ...createUiSlice(sanitizedSet, get, api),

    // 💉 CHIRURGIE: Betty Slice injiziert
    ...createBettySlice(sanitizedSet, get, api),

    ...createPremiumSlice(sanitizedSet, get, api),

    // PE Profit: natives Zustand-set (sanitizedSet kann Array-Updates verschlucken)
    ...createPeProfitSlice(set, get, api),

    ...createTeamBonusSlice(sanitizedSet, get, api),

    // 💉 TYPESCRIPT-PLACEHOLDER: Verhindert rote Fehler.
    // Die echte Speicherung passiert direkt im Kalkulator über setClientData (Firebase Sync).
    preisliste: [],
    addPreislistenEintrag: () => {},
    removePreislistenEintrag: () => {},
    updatePreislistenEintrag: () => {}
  };
});

export default useAppStore;